import React from "react";
import { DollarSign, Calendar, Home, UserCircle } from "lucide-react";
import { CurrencySymbol } from "../../../utils/enums";

const formatPrice = (value) => {
  if (value == null || value === "" || isNaN(Number(value))) return "–";
  const num = Number(value);
  if (num >= 1000000) return `${CurrencySymbol.NGN} ${(num / 1000000).toFixed(1)}m`;
  if (num >= 1000) return `${CurrencySymbol.NGN} ${Math.round(num / 1000)}k`;
  return `${CurrencySymbol.NGN} ${num}`;
};

const AgentOverviewCard = ({ AgentData, property }) => {
  const agentName = AgentData?.data?.first_name || AgentData?.first_name || "Agent";
  const medianPrice = AgentData?.data?.medianPrice;
  const medianDays = AgentData?.data?.medianDaysAdvertised ?? AgentData?.data?.median_days_advertised ?? 0;
  const leadSold = AgentData?.data?.property_sold ?? AgentData?.data?.properties_sold_lead ?? 0;
  const secondarySold = AgentData?.data?.properties_sold_secondary ?? (Array.isArray(property) ? property.length : 0);

  const metrics = [
    {
      value: formatPrice(medianPrice),
      label: "Median sold price",
      icon: DollarSign,
    },
    {
      value: medianDays != null ? String(medianDays) : "–",
      label: "Median days advertised",
      icon: Calendar,
    },
    {
      value: leadSold != null ? String(Math.round(Number(leadSold))) : "–",
      label: "Properties sold (as lead agent)",
      icon: Home,
    },
    {
      value: secondarySold != null ? String(secondarySold) : "–",
      label: "Properties sold (as secondary agent)",
      icon: UserCircle,
    },
  ];

  return (
    <div className="bg-white rounded-xl p-5 md:p-6 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.16)]">
      <h3 className="text-[#171717] font-bold text-lg md:text-xl">
        {agentName}'s performance snapshot
      </h3>
      <p className="text-[#737373] text-sm mt-1 mb-5 md:mb-6">
        Performance in the last 12 months
      </p>
      <div className="grid grid-cols-2 gap-3 md:gap-4">
        {metrics.map((item, index) => {
          const Icon = item.icon;
          return (
            <div
              key={index}
              className="bg-[#F5F5F5] rounded-xl p-4 md:p-5 flex items-start justify-between gap-3"
            >
              <div className="min-w-0 flex-1">
                <div className="text-[#171717] font-bold text-xl md:text-2xl">
                  {item.value}
                </div>
                <div className="text-[#737373] text-xs md:text-sm mt-1">
                  {item.label}
                </div>
              </div>
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#E3F2FD] flex items-center justify-center">
                <Icon className="w-5 h-5 text-[#097FE6]" strokeWidth={2} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgentOverviewCard;
